<template>
  <div v-if="isVisible">
    <button type="button" id="btn_news_widget" @click="showModal = true">
      <i class="fa-solid fa-bolt me-2"></i>
      Acontecendo agora
    </button>

    <ModalDialog width="1000px" title="Acontecendo agora" v-model="showModal" overflow="hidden">
      <div id="news_widget">
        <iframe src="https://zuum.com.br/widget/noticias?key=zw_bb87db4a52098c1d2b1bc603a8ee48b52b6d6aff"
          width="100%" height="100%" style="border:0;border-radius:12px" title="Notícias"></iframe>
      </div>
    </ModalDialog>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import ModalDialog from '@/components/ModalDialog.vue';
import { useAuthStore } from '@/stores/AuthStore';

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const showModal = ref(false);

const isVisible = computed(() => {
  if (!user.value) {
    return false;
  }

  if (user.value.profile_type !== 'redator') {
    return false;
  }

  if (user.value.status !== 'active') {
    return false;
  }

  return true;
});
</script>

<style scoped>
#btn_news_widget {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  border: 0;
  border-radius: 30px;
  padding: 12px 22px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  background-color: #583a8e;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

#btn_news_widget:hover {
  background-color: #6b47ab;
}

#news_widget {
  height: 65vh;
  min-height: 320px;
}
</style>
